import { GapWaiverResponse } from '../../services';

interface SubSectionElement {
  text: string;
  value: string;
  isVisible: boolean;
  key: number;
}

const usePaymentDetailsVm = (gapWaiver: GapWaiverResponse) => {
  const termLengthDifference = gapWaiver.financing?.termLengthDifference ?? 0;
  const termLengthUnit = Math.abs(termLengthDifference) === 1 ? 'month' : 'months';

  const getSubSectionElements = (): SubSectionElement[] => [
    {
      text: 'New monthly payment with GAP',
      value: `$${gapWaiver.financing?.monthlyPayment ?? 0}`,
      isVisible: gapWaiver.isApplied,
      key: 1
    },
    {
      text: 'Current monthly payment',
      value: `$${gapWaiver.financing?.monthlyPayment ?? 0}`,
      isVisible: !gapWaiver.isApplied,
      key: 2
    },
    {
      text: 'Additional down payment',
      value: `$${gapWaiver.financing?.downPaymentDifference ?? 0}`,
      isVisible: !gapWaiver.isApplied,
      key: 3
    },
    {
      text: 'Additional monthly payment',
      value:
        (gapWaiver.financing?.monthlyPaymentDifference ?? 0) > 0
          ? `+$${gapWaiver.financing?.monthlyPaymentDifference ?? 0} mo`
          : `-$${Math.abs(gapWaiver.financing?.monthlyPaymentDifference ?? 0)} mo`,
      isVisible: !gapWaiver.isApplied,
      key: 4
    },
    {
      text: 'Additional loan length',
      value:
        termLengthDifference > 0
          ? `+${termLengthDifference} ${termLengthUnit}`
          : `-${Math.abs(termLengthDifference)} ${termLengthUnit}`,
      isVisible: !gapWaiver.isApplied && termLengthDifference !== 0,
      key: 5
    }
  ];

  return {
    subSectionElements: getSubSectionElements()
  };
};

export default usePaymentDetailsVm;
